module.exports = __webpack_public_path__ + "static/media/CallingDirectoryGrey.f96d2a53.svg";